import { Component, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-unsaved-changes-dialog",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./unsaved-changes-dialog.component.html",
  styleUrls: ["./unsaved-changes-dialog.component.scss"],
})
export class UnsavedChangesDialogComponent {
  @Output() close = new EventEmitter<void>();
  @Output() saveAndClose = new EventEmitter<void>();
}